import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";

const Modal = ({
  open,
  onOpenChange,
  title,
  icon: Icon,
  children,
  footer,
  maxWidth = "max-w-md",
  className,
  contentClassName,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        onPointerDownOutside={(e) => {
          if (e.target.closest('[id^="react-select"]')) {
            e.preventDefault();
          }
        }}
        onInteractOutside={(e) => {
          if (e.target.closest('[id^="react-select"]')) {
            e.preventDefault();
          }
        }}
        className={cn(
          "flex flex-col p-0 gap-0 overflow-hidden border shadow-2xl bg-background max-h-[90vh] w-full focus:outline-none focus:ring-0 focus-visible:outline-none",
          maxWidth,
          className,
        )}
      >
        <DialogHeader className="px-6 py-4 border-b flex-shrink-0 flex flex-row items-center gap-2 space-y-0 bg-muted/20">
          {Icon && <Icon className="h-5 w-5 text-primary" />}
          <DialogTitle className="text-lg font-bold">{title}</DialogTitle>
          <DialogDescription className="sr-only">
            {typeof title === "string" ? title : "Modal dialog"}
          </DialogDescription>
        </DialogHeader>

        <div
          className={cn("flex-1 overflow-y-auto px-6 py-4", contentClassName)}
        >
          {children}
        </div>

        {footer && (
          <DialogFooter className="px-6 py-4 border-t flex-shrink-0 bg-muted/20">
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  icon: PropTypes.elementType,
  children: PropTypes.node,
  footer: PropTypes.node,
  maxWidth: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
};

export default Modal;
